export const isEmptyText = (text) => {
  return text.trim() === ""
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const validatePhone = (phone) => {
  const re = /^\+?\d{1,4}[-.\s]?\d{2,4}[-.\s]?\d{3,4}[-.\s]?\d{3,4}$/
  return re.test(String(phone))
}

export const formatNumbers = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
} 

export const formatCurrency = (number) => {
  return '$' + formatNumbers(number)
}

export const isMobileDevice = () => {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    return true
  }
  return false
}

export const detectArticleReadingTime = (text) => {
  const wordsPerMinute = 200
  const numberOfWords = text?.split(/\s/g).length
  return Math.ceil(numberOfWords / wordsPerMinute)
}

export const randomNumRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}